export enum AuditTrailAction {
  Undefined = 0,

  StorageAreaApiCreate = 100,
  StorageAreaApiUpdate = 101,
  StorageAreaApiDelete = 102,
  StorageAreaApiUndoDelete = 103,
  StorageAreaApiUpdateDisplayText = 104,

  ShapeApiCreate = 200,
  ShapeApiUpdate = 201,
  ShapeApiDelete = 202,
  ShapeApiUndoDelete = 203,

  ProductApiCreate = 300,
  ProductApiDelete = 301,
  ProductApiUpdate = 302,

  VehicleApiCreate = 400,
  VehicleApiUpdate = 401,
  VehicleApiDelete = 402,

  InventoryApiExecute = 500,
  InventoryApiUndo = 501,

  LogSorterApiCreate = 600,
  LogSorterApiDelete = 601,
  LogSorterApiUpdate = 602,

  MapStyleApiCreate = 700,
  MapStyleApiDelete = 701,
  MapStyleApiUpdate = 702,

  MoveApiUndo = 802,
  MoveApi = 803,

  SyncMove = 900,
  SyncInventory = 901,
  SyncProduct = 902,
  SyncShape = 903,
  SyncStorageArea = 904,
  SyncUndoMove = 905,
  SyncUndoInventory = 906,
  SyncUndoStorageArea = 907,
  SyncSetting = 908,
  SyncLogSorter = 909,
  SyncMapStyle = 910,
  SyncVehicle = 911,
  SyncFeatureFlag = 912,
  SyncInboundDelivery = 913,
  SyncInboundLoad = 914,
  SyncPackage = 915,
  SyncInboundDeliveryTransaction = 916,
  SyncOutboundDelivery = 917,
  SyncOutboundDeliveryTransaction = 918,

  CoilApiCreate = 1000,
  CoilApiUpdate = 1001,
  CoilApiDelete = 1002,

  SettingUpdate = 1100,

  FeatureFlagApi = 1200,

  ProductGroupApiCreate = 1300,
  ProductGroupApiUpdate = 1301,
  ProductGroupApiDelete = 1302,
  ProductGroupSync = 1303,

  DashboardCreate = 1400,
  DashboardUpdate = 1401,
  DashboardDelete = 1402,

  ProductionOrderCreate = 1500,
  ProductionOrderUpdate = 1501,
  ProductionOrderDelete = 1502,
  ProductionOrderChange = 1503,
  ProductionOrderSync = 1505,

  MoveTimberFromLogSorterBins = 1600,

  InboundDeliveryCreate = 1700,
  InboundDeliveryDelete = 1701,
  InboundDeliveryUpdate = 1702,
  InboundDeliveryTransaction = 1703,
  OutboundDeliveryCreate = 1704,
  OutboundDeliveryDelete = 1705,
  OutboundDeliveryUpdate = 1706,
  OutboundDeliveryTransaction = 1707,

  InboundLoadCreate = 1800,

  PackageApiCreate = 1900,
  PackageApiUpdate = 1901,
  PackageApiDelete = 1902,
  PackagingApiCreate = 1903,
  PackagingApiUpdate = 1904,
  PackagingApiDelete = 1905,
  PackageTypeApiCreate = 1906,
  PackageTypeApiUpdate = 1907,
  PackageTypeApiDelete = 1908,

  ExternalProductBatch = 2000,
  ExternalDeliveries = 2001,
  ExternalVessels = 2002,
  ExternalLoadUnits = 2003,
}
